export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5643.8ec6ef4a.jpg";